module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_5012.9f3dbcb0.png";